/* OUD CLOSET — bespoke AJAX cart drawer.
   Powers add-to-cart from the PDP and the collection hover size-buttons,
   then slides in an on-brand bag. No Dawn product-form dependency.
   All dynamic strings from /cart.js are escaped via esc() before insertion. */
(function () {
  'use strict';

  var routes = window.routes || {};
  var addUrl = (routes.cart_add_url || '/cart/add') + '.js';
  var changeUrl = (routes.cart_change_url || '/cart/change') + '.js';
  var cartGetUrl = (routes.cart_url || '/cart') + '.js';

  var root = document.querySelector('[data-oud-cart]');
  if (!root) return;

  var body = root.querySelector('[data-oud-cart-body]');
  var foot = root.querySelector('[data-oud-cart-foot]');
  var emptyEl = root.querySelector('[data-oud-cart-empty]');
  var subtotalEl = root.querySelector('[data-oud-cart-subtotal]');
  var html = document.documentElement;
  var busy = false;

  /* ---------- money ---------- */
  function formatWithDelimiters(cents, precision, thousands, decimal) {
    precision = precision == null ? 2 : precision;
    thousands = thousands || ',';
    decimal = decimal || '.';
    if (isNaN(cents) || cents == null) return '0';
    var number = (cents / 100).toFixed(precision);
    var parts = number.split('.');
    var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    var rest = parts[1] ? decimal + parts[1] : '';
    return dollars + rest;
  }
  function money(cents) {
    var fmt = ((window.OudShop && window.OudShop.moneyFormat) || '${{amount}}').replace(/<[^>]+>/g, '');
    var match = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    var key = match ? match[1] : 'amount';
    var value;
    switch (key) {
      case 'amount_no_decimals': value = formatWithDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = formatWithDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = formatWithDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': value = formatWithDelimiters(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': value = formatWithDelimiters(cents, 0, ' '); break;
      default: value = formatWithDelimiters(cents, 2);
    }
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, value);
  }

  function esc(s) {
    return (s == null ? '' : String(s)).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function setCount(n) {
    Array.prototype.forEach.call(document.querySelectorAll('[data-oud-cart-count], .oud-cartcount'), function (el) {
      el.textContent = n;
      el.classList.toggle('is-empty', n === 0);
    });
  }

  /* ---------- open / close ---------- */
  function open() { root.classList.add('is-open'); root.setAttribute('aria-hidden', 'false'); html.style.overflow = 'hidden'; }
  function close() { root.classList.remove('is-open'); root.setAttribute('aria-hidden', 'true'); html.style.overflow = ''; }

  /* ---------- render ----------
     Builds rows from the store's own /cart.js. Every interpolated value is
     either a number (line/quantity/price) or passed through esc(); URLs and
     titles are escaped, so the assembled markup contains no unescaped input. */
  function sized(url, w) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + (w || 200);
  }
  function itemMarkup(it, line) {
    var opts = (it.options_with_values || [])
      .filter(function (o) { return o.value && o.value !== 'Default Title'; })
      .map(function (o) { return esc(o.name) + ' ' + esc(o.value) + (o.name === 'Length' ? '&Prime;' : ''); })
      .join(' &middot; ');
    var imgTag = it.image ? '<img src="' + esc(sized(it.image, 200)) + '" alt="" width="64" height="84" loading="lazy">' : '';
    return '' +
      '<div class="oud-citem" data-line="' + line + '">' +
        '<a class="oud-citem__img" href="' + esc(it.url) + '">' + imgTag + '</a>' +
        '<div class="oud-citem__info">' +
          '<a class="oud-citem__name" href="' + esc(it.url) + '">' + esc((it.product_title || it.title || '').replace(' Abaya', '')) + '</a>' +
          (opts ? '<div class="oud-citem__opt">' + opts + '</div>' : '') +
          '<div class="oud-citem__row">' +
            '<div class="oud-qty">' +
              '<button type="button" data-oud-qty="-1" data-line="' + line + '" aria-label="Decrease quantity">&minus;</button>' +
              '<span>' + (parseInt(it.quantity, 10) || 0) + '</span>' +
              '<button type="button" data-oud-qty="1" data-line="' + line + '" aria-label="Increase quantity">+</button>' +
            '</div>' +
            '<span class="oud-citem__price">' + esc(money(it.final_line_price)) + '</span>' +
          '</div>' +
          '<button type="button" class="oud-citem__remove" data-oud-remove data-line="' + line + '">Remove</button>' +
        '</div>' +
      '</div>';
  }
  function render(cart) {
    setCount(cart.item_count);
    if (!cart.item_count) {
      body.textContent = '';
      foot.hidden = true;
      emptyEl.hidden = false;
      return;
    }
    emptyEl.hidden = true;
    foot.hidden = false;
    body.innerHTML = cart.items.map(function (it, i) { return itemMarkup(it, i + 1); }).join('');
    subtotalEl.textContent = money(cart.total_price);
  }

  function getCart() { return fetch(cartGetUrl, { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }); }
  function refresh() { return getCart().then(render); }

  function add(id, qty) {
    if (!id || busy) return Promise.resolve();
    busy = true;
    return fetch(addUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: id, quantity: qty || 1 })
    }).then(function (r) { return r.json(); }).then(function (res) {
      if (res && res.status && res.status !== 200) { busy = false; return; }
      return refresh().then(function () { busy = false; open(); });
    }).catch(function () { busy = false; });
  }

  function change(line, qty) {
    if (busy) return;
    busy = true;
    fetch(changeUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty })
    }).then(function (r) { return r.json(); }).then(function (cart) { render(cart); busy = false; }).catch(function () { busy = false; });
  }

  /* ---------- wire ---------- */
  var overlay = root.querySelector('[data-oud-cart-overlay]');
  if (overlay) overlay.addEventListener('click', close);
  Array.prototype.forEach.call(root.querySelectorAll('[data-oud-cart-close]'), function (b) { b.addEventListener('click', close); });
  var checkout = root.querySelector('[data-oud-cart-checkout]');
  if (checkout) checkout.addEventListener('click', function () { window.location.href = '/checkout'; });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && root.classList.contains('is-open')) close(); });

  body.addEventListener('click', function (e) {
    var q = e.target.closest('[data-oud-qty]');
    if (q) {
      var span = q.parentNode.querySelector('span');
      var cur = parseInt(span.textContent, 10) || 0;
      change(parseInt(q.getAttribute('data-line'), 10), Math.max(0, cur + parseInt(q.getAttribute('data-oud-qty'), 10)));
      return;
    }
    var rm = e.target.closest('[data-oud-remove]');
    if (rm) change(parseInt(rm.getAttribute('data-line'), 10), 0);
  });

  /* header cart icons -> open the drawer */
  Array.prototype.forEach.call(document.querySelectorAll('#cart-icon-bubble, .oud-hdr__mobcart'), function (a) {
    a.addEventListener('click', function (e) { e.preventDefault(); refresh().then(open); });
  });

  /* PDP add-to-cart (intercept the form submit) */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('#oud-pdp-form');
    if (!form) return;
    e.preventDefault();
    var idInput = form.querySelector('[name="id"]');
    add(idInput && idInput.value, 1);
  });

  /* collection hover size-buttons + any inline add buttons */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-oud-add]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    if (btn.disabled || btn.getAttribute('aria-disabled') === 'true') return;
    add(btn.getAttribute('data-variant-id'), 1);
  });

  setCount((window.OudShop && window.OudShop.cartCount) || 0);
})();
